import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import {
  userTableCustomStyles,
  terminalTableCustomStyles,
} from "../../../utils/TableCustomStyles";
import ExpandableTerminalComponent from "./ExpandableTerminalComponent";

function PortMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [terminalData, setTerminalData] = useState([]);
  const [chargeData, setChargeData] = useState([]);
  const [containerData, setContainerData] = useState([]);
  const [terminalDataPending, setTerminalDataPending] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // ---------- Add form state (Port) ----------
  const [addName, setAddName] = useState("");
  const [addType, setAddType] = useState("SEAPORT");
  const [addItaCode, setAddItaCode] = useState("");
  const [addCity, setAddCity] = useState("");
  const [addPincode, setAddPincode] = useState("");
  const [addState, setAddState] = useState("");
  const [addCountry, setAddCountry] = useState("");
  const [addCurrency, setAddCurrency] = useState("");
  const [addCustomsDetails, setAddCustomsDetails] = useState("");
  const [addHideIfDestination, setAddHideIfDestination] = useState("NO");
  const [addStatus, setAddStatus] = useState("ACTIVE");

  // Add field errors
  const [showNameError, setShowNameError] = useState(false);
  const [showItaCodeError, setShowItaCodeError] = useState(false);
  const [showCityError, setShowCityError] = useState(false);
  const [showPincodeError, setShowPincodeError] = useState(false);
  const [showStateError, setShowStateError] = useState(false);
  const [showCountryError, setShowCountryError] = useState(false);
  const [showCurrencyError, setShowCurrencyError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state (Port) ----------
  const [updateId, setUpdateId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateType, setUpdateType] = useState("SEAPORT");
  const [updateItaCode, setUpdateItaCode] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updatePincode, setUpdatePincode] = useState("");
  const [updateState, setUpdateState] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const [updateCurrency, setUpdateCurrency] = useState("");
  const [updateCustomDetails, setUpdateCustomDetails] = useState("");
  const [updateHideIfDestination, setUpdateHideIfDestination] = useState("NO");
  const [updateStatus, setUpdateStatus] = useState("ACTIVE");

  // Update field errors
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateItaCodeError, setShowUpdateItaCodeError] = useState(false);
  const [showUpdateCityError, setShowUpdateCityError] = useState(false);
  const [showUpdatePincodeError, setShowUpdatePincodeError] = useState(false);
  const [showUpdateStateError, setShowUpdateStateError] = useState(false);
  const [showUpdateCountryError, setShowUpdateCountryError] = useState(false);
  const [showUpdateCurrencyError, setShowUpdateCurrencyError] = useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // Tabs for update canvas
  const [showUpdatePortDetails, setShowUpdatePortDetails] = useState(true);
  const [showUpdateTerminalDetails, setShowUpdateTerminalDetails] =
    useState(false);
  const [showUpdateUploadDetails, setShowUpdateUploadDetails] = useState(false);

  // ---------- Terminal state ----------
  const [terminalName, setTerminalName] = useState("");
  const [showTerminalNameError, setShowTerminalNameError] = useState(false);
  const [updateTerminalName, setUpdateTerminalName] = useState("");
  const [showUpdateTerminalNameError, setShowUpdateTerminalNameError] =
    useState(false);
  const [updateTerminalId, setUpdateTerminalId] = useState("");
  const [showUpdateTerminalForm, setShowUpdateTerminalForm] = useState(false);
  const [showTerminalDeleteModal, setShowTerminalDeleteModal] = useState(false);
  const [terminalRecordForDelete, setTerminalRecordForDelete] = useState(null);
  const [showTerminalDeleteLoader, setShowTerminalDeleteLoader] =
    useState(false);
  const [showAddTerminalLoader, setShowAddTerminalLoader] = useState(false);
  const [showUpdateTerminalLoader, setShowUpdateTerminalLoader] =
    useState(false);

  // ---------- Uploads state ----------
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploadFileNames, setUploadFileNames] = useState([]);
  const [showUploadFilesLoader, setShowUploadFilesLoader] = useState(false);
  const [portUploads, setPortUploads] = useState([]);
  const [portUploadDataPending, setPortUploadDataPending] = useState(false);
  const [deletePortUploadModal, setDeletePortUploadModal] = useState(false);
  const [uploadFilesSerialNumber, setUploadFilesSerialNumber] = useState("");
  const [deleteUploadFileName, setDeleteUploadFileName] = useState("");
  const [showDeleteUploadFilesLoader, setShowDeleteUploadFilesLoader] =
    useState(false);

  // ========== Validation Helpers ==========
  const isNumeric = (val) => /^\d+$/.test(val);
  const isAlphabetic = (val) => /^[A-Za-z]+$/.test(val); // only letters, no spaces

  // ========== Real‑time error helpers for Port Add ==========
  const hasAnyAddError = () => {
    return (
      showNameError ||
      showItaCodeError ||
      showCityError ||
      showPincodeError ||
      showStateError ||
      showCountryError ||
      showCurrencyError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addName) errors.push("Name is required");
    if (!addItaCode) errors.push("ITA Code is required");
    if (!addCity) errors.push("City is required");
    if (!addState) errors.push("State is required");
    else if (!isAlphabetic(addState))
      errors.push(
        "State must contain only letters (no spaces, digits, or special characters)",
      );
    if (!addPincode) errors.push("Pincode is required");
    else if (!isNumeric(addPincode))
      errors.push("Pincode must contain only digits");
    if (!addCountry) errors.push("Country is required");
    if (!addCurrency) errors.push("Currency is required");
    return errors;
  };

  // ========== Real‑time error helpers for Port Update ==========
  const hasAnyUpdateError = () => {
    return (
      showUpdateNameError ||
      showUpdateItaCodeError ||
      showUpdateCityError ||
      showUpdatePincodeError ||
      showUpdateStateError ||
      showUpdateCountryError ||
      showUpdateCurrencyError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateName) errors.push("Name is required");
    if (!updateItaCode) errors.push("ITA Code is required");
    if (!updateCity) errors.push("City is required");
    if (!updateState) errors.push("State is required");
    else if (!isAlphabetic(updateState))
      errors.push(
        "State must contain only letters (no spaces, digits, or special characters)",
      );
    if (!updatePincode) errors.push("Pincode is required");
    else if (!isNumeric(updatePincode))
      errors.push("Pincode must contain only digits");
    if (!updateCountry) errors.push("Country is required");
    if (!updateCurrency) errors.push("Currency is required");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getPorts = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/",
      );
      setData(response.data);
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getTerminal = async (port) => {
    setTerminalDataPending(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/terminal?port=" + port,
      );
      setTerminalData(response.data);
    } catch (err) {
      toast.error("Error in fetching terminal data! Try again.");
    } finally {
      setTerminalDataPending(false);
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const sorted_data = response.data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      setCountryData(sorted_data);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getCurrency = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/currency/",
      );
      const sorted_data = response.data.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setCurrencyData(sorted_data);
    } catch (err) {
      toast.error("Error in fetching currency data! Try again.");
    }
  };

  const getCharges = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/charge/",
      );
      setChargeData(response.data);
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  };

  const getContainer = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/product/",
      );
      setContainerData(response.data);
    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getPorts();
    getCountry();
    getCurrency();
    getCharges();
    getContainer();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers (Port) ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/" + id + "/",
      );
      setShowDeleteModal(false);
      getPorts();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic (Port) ==========
  const resetAddForm = () => {
    setAddName("");
    setAddType("SEAPORT");
    setAddItaCode("");
    setAddCity("");
    setAddPincode("");
    setAddState("");
    setAddCountry("");
    setAddCurrency("");
    setAddCustomsDetails("");
    setAddHideIfDestination("NO");
    setAddStatus("ACTIVE");
    setShowNameError(false);
    setShowItaCodeError(false);
    setShowCityError(false);
    setShowPincodeError(false);
    setShowStateError(false);
    setShowCountryError(false);
    setShowCurrencyError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewPort = async (e) => {
    e.preventDefault();

    setShowNameError(!addName);
    setShowItaCodeError(!addItaCode);
    setShowCityError(!addCity);
    setShowStateError(!addState || !isAlphabetic(addState));
    setShowPincodeError(!addPincode || !isNumeric(addPincode));
    setShowCountryError(!addCountry);
    setShowCurrencyError(!addCurrency);
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !addName ||
      !addItaCode ||
      !addCity ||
      !addState ||
      !addPincode ||
      !addCountry ||
      !addCurrency ||
      !isAlphabetic(addState) ||
      !isNumeric(addPincode)
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      name: addName,
      type: addType,
      ita_code: addItaCode,
      city: addCity,
      pincode: addPincode,
      state: addState,
      country: addCountry,
      currency: addCurrency,
      customs_details: addCustomsDetails,
      hide_if_destination: addHideIfDestination === "YES",
      status: addStatus,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Port Created Successfully");
        handleAddModalClose();
        getPorts();
      }
    } catch (err) {
      toast.error("Error creating port");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic (Port) ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateName("");
    setUpdateType("SEAPORT");
    setUpdateItaCode("");
    setUpdateCity("");
    setUpdatePincode("");
    setUpdateState("");
    setUpdateCountry("");
    setUpdateCurrency("");
    setUpdateCustomDetails("");
    setUpdateHideIfDestination("NO");
    setUpdateStatus("ACTIVE");
    setShowUpdateNameError(false);
    setShowUpdateItaCodeError(false);
    setShowUpdateCityError(false);
    setShowUpdatePincodeError(false);
    setShowUpdateStateError(false);
    setShowUpdateCountryError(false);
    setShowUpdateCurrencyError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    setPortUploads([]);
    setTerminalData([]);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
    setShowUpdatePortDetails(true);
    setShowUpdateTerminalDetails(false);
    setShowUpdateUploadDetails(false);
    setShowUpdateTerminalForm(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateName(row.name);
    setUpdateType(row.type);
    setUpdateItaCode(row.ita_code);
    setUpdateCity(row.city);
    setUpdatePincode(row.pincode);
    setUpdateState(row.state);
    setUpdateCountry(row.country || "");
    setUpdateCurrency(row.currency || "");
    setUpdateCustomDetails(row.customs_details || "");
    setUpdateHideIfDestination(row.hide_if_destination ? "YES" : "NO");
    setUpdateStatus(row.status);
    setPortUploads(row.upload_urls || []);
    getTerminal(row.id);
    // Reset errors
    setShowUpdateNameError(false);
    setShowUpdateItaCodeError(false);
    setShowUpdateCityError(false);
    setShowUpdatePincodeError(false);
    setShowUpdateStateError(false);
    setShowUpdateCountryError(false);
    setShowUpdateCurrencyError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
  };

  const updatePorts = async (e) => {
    e.preventDefault();

    setShowUpdateNameError(!updateName);
    setShowUpdateItaCodeError(!updateItaCode);
    setShowUpdateCityError(!updateCity);
    setShowUpdateStateError(!updateState || !isAlphabetic(updateState));
    setShowUpdatePincodeError(!updatePincode || !isNumeric(updatePincode));
    setShowUpdateCountryError(!updateCountry);
    setShowUpdateCurrencyError(!updateCurrency);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateName ||
      !updateItaCode ||
      !updateCity ||
      !updateState ||
      !updatePincode ||
      !updateCountry ||
      !updateCurrency ||
      !isAlphabetic(updateState) ||
      !isNumeric(updatePincode)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      name: updateName,
      type: updateType,
      ita_code: updateItaCode,
      city: updateCity,
      pincode: updatePincode,
      state: updateState,
      country: updateCountry,
      currency: updateCurrency,
      customs_details: updateCustomDetails,
      hide_if_destination: updateHideIfDestination === "YES",
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/" + updateId + "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Port Updated Successfully");
        handleUpdateModalClose();
        getPorts();
      }
    } catch (err) {
      toast.error("Error updating port");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Terminal logic ==========
  const resetTerminalForm = () => {
    setTerminalName("");
    setShowTerminalNameError(false);
  };

  const addNewTerminal = async (e) => {
    e.preventDefault();
    setShowTerminalNameError(!terminalName);
    if (!terminalName) return;

    setShowAddTerminalLoader(true);
    const payload = {
      name: terminalName,
      port: updateId,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };
    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/terminal/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Terminal Created Successfully");
        resetTerminalForm();
        getTerminal(updateId);
      }
    } catch (err) {
      toast.error("Error creating terminal");
    } finally {
      setShowAddTerminalLoader(false);
    }
  };

  const handleSetUpdateTerminalData = (row) => {
    setUpdateTerminalId(row.id);
    setUpdateTerminalName(row.name);
    setShowUpdateTerminalForm(true);
    setShowUpdateTerminalNameError(false);
  };

  const updateTerminal = async (e) => {
    e.preventDefault();
    setShowUpdateTerminalNameError(!updateTerminalName);
    if (!updateTerminalName) return;

    setShowUpdateTerminalLoader(true);
    const payload = {
      name: updateTerminalName,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/terminal/" +
          updateTerminalId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Terminal Updated Successfully");
        setShowUpdateTerminalForm(false);
        setUpdateTerminalId("");
        setUpdateTerminalName("");
        getTerminal(updateId);
      }
    } catch (err) {
      toast.error("Error updating terminal");
    } finally {
      setShowUpdateTerminalLoader(false);
    }
  };

  const deleteSelectedTerminalRecord = async (id) => {
    setShowTerminalDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/terminal/" + id + "/",
      );
      setShowTerminalDeleteModal(false);
      getTerminal(updateId);
      toast.success("Terminal deleted successfully");
    } catch (err) {
      toast.error("Error deleting terminal");
    } finally {
      setShowTerminalDeleteLoader(false);
    }
  };

  // ========== Uploads logic ==========
  const handleUploadsFileChange = (files) => {
    const fileArray = Array.from(files);
    const names = fileArray.map((file) => file.name);
    setUploadFileNames(names);
    setUploadFiles(files);
  };

  const addPortUploads = async (e) => {
    e.preventDefault();
    if (uploadFiles.length === 0) return;

    setShowUploadFilesLoader(true);
    const formData = new FormData();
    formData.append("id", updateId);
    for (let i = 0; i < uploadFiles.length; i++) {
      formData.append("upload", uploadFiles[i]);
    }
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/portuploads/",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("Files Uploaded Successfully");
        setPortUploads(response.data.upload_urls);
        setUploadFiles([]);
        setUploadFileNames([]);
        document.getElementById("uploads").value = "";
      }
    } catch (err) {
      toast.error("Error uploading files");
    } finally {
      setShowUploadFilesLoader(false);
    }
  };

  const setDeleteUploadDetails = (row) => {
    setDeletePortUploadModal(true);
    setUploadFilesSerialNumber(row.serial_number);
    setDeleteUploadFileName(row.filename);
  };

  const deletePortUploads = async () => {
    setShowDeleteUploadFilesLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/deleteportuploads/",
        {
          id: updateId,
          serial_number: uploadFilesSerialNumber,
        },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("File Deleted Successfully");
        setPortUploads(response.data.upload_urls);
      }
    } catch (err) {
      toast.error("Error deleting file");
    } finally {
      setShowDeleteUploadFilesLoader(false);
      setDeletePortUploadModal(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Type", selector: (row) => row.type, sortable: true },
    { name: "ITA Code", selector: (row) => row.ita_code, sortable: true },
    {
      name: "Address",
      selector: (row) => `${row.city}, ${row.state} - ${row.pincode}`,
      sortable: true,
    },
    {
      name: "Country",
      selector: (row) => row.country_data?.long_name,
      sortable: true,
    },
    {
      name: "Currency",
      selector: (row) => row.currency_data?.symbol,
      sortable: true,
    },
    {
      name: "Custom Details",
      selector: (row) => row.customs_details,
      sortable: true,
    },
    {
      name: "Hide if Destination",
      selector: (row) => (row.hide_if_destination ? "YES" : "NO"),
      sortable: true,
    },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:port:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:port:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const terminalcolumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      width: "90%",
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes(
            "master:terminal:update",
          ) && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              onClick={() => handleSetUpdateTerminalData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes(
            "master:terminal:delete",
          ) && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => {
                setTerminalRecordForDelete(row);
                setShowTerminalDeleteModal(true);
              }}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const uploadcolumns = [
    { name: "File Name", selector: (row) => row.filename, sortable: true },
    {
      name: "Preview",
      selector: (row) => (
        <img
          className="img img-thumbnail"
          src={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
          height={40}
          width={40}
          alt="preview"
        />
      ),
    },
    { name: "File Type", selector: (row) => row.filetype, sortable: true },
    {
      name: "File Size",
      selector: (row) => `${row.filesize} ${row.fileunit}`,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          <Button
            className="btn btn-sm btn-inox-green border-0 mx-2"
            title="Preview"
          >
            <a
              className="text-decoration-none text-white"
              href={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-eye"></i>
            </a>
          </Button>
          <Button
            className="btn btn-sm bg-danger border-0 mx-2"
            title="Delete"
            onClick={() => setDeleteUploadDetails(row)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="PortMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Port Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:port:add") ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Port</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Delete Modal (Port) */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-8">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Record ({updateName})
              </h4>
              <Button
                className={`${showUpdatePortDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdatePortDetails(true);
                  setShowUpdateTerminalDetails(false);
                  setShowUpdateUploadDetails(false);
                }}
              >
                Details
              </Button>
              <Button
                className={`${showUpdateTerminalDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdatePortDetails(false);
                  setShowUpdateTerminalDetails(true);
                  setShowUpdateUploadDetails(false);
                }}
              >
                Terminals
              </Button>
              <Button
                className={`${showUpdateUploadDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdatePortDetails(false);
                  setShowUpdateTerminalDetails(false);
                  setShowUpdateUploadDetails(true);
                }}
              >
                Uploads
              </Button>
            </div>
            <div className="col-4">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          {/* Port Details Tab */}
          {showUpdatePortDetails && (
            <form onSubmit={updatePorts}>
              <div className="row">
                {/* Name */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_name">
                    Name:
                    <span className="text-danger">
                      {showUpdateNameError ? " Name required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_name"
                    placeholder="Enter Name"
                    value={updateName}
                    onChange={(e) => {
                      setUpdateName(e.target.value);
                      setShowUpdateNameError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      setShowUpdateNameError(e.target.value === "");
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                {/* Type */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_type">Type:</label>
                  <select
                    className="form-select form-control-sm"
                    id="update_type"
                    value={updateType}
                    onChange={(e) => setUpdateType(e.target.value)}
                  >
                    <option value="SEAPORT">SEAPORT</option>
                    <option value="DRYPORT">DRYPORT</option>
                  </select>
                </div>

                {/* ITA Code */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_ita_code">
                    ITA Code:
                    <span className="text-danger">
                      {showUpdateItaCodeError ? " Code required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_ita_code"
                    placeholder="Enter Code"
                    value={updateItaCode}
                    onChange={(e) => {
                      setUpdateItaCode(e.target.value);
                      setShowUpdateItaCodeError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      setShowUpdateItaCodeError(e.target.value === "");
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                {/* City */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_city">
                    City:
                    <span className="text-danger">
                      {showUpdateCityError ? " City required" : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_city"
                    placeholder="Enter City"
                    value={updateCity}
                    onChange={(e) => {
                      setUpdateCity(e.target.value);
                      setShowUpdateCityError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      setShowUpdateCityError(e.target.value === "");
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                {/* Pincode */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_pincode">
                    Pincode:
                    <span className="text-danger">
                      {showUpdatePincodeError
                        ? updatePincode
                          ? " Must contain only digits"
                          : " Required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_pincode"
                    placeholder="Enter Pincode"
                    value={updatePincode}
                    onChange={(e) => {
                      setUpdatePincode(e.target.value);
                      setShowUpdatePincodeError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      setShowUpdatePincodeError(!val || !isNumeric(val));
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                {/* State */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_state">
                    State:
                    <span className="text-danger">
                      {showUpdateStateError
                        ? updateState
                          ? " Must contain only letters"
                          : " Required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_state"
                    placeholder="Enter State "
                    value={updateState}
                    onChange={(e) => {
                      setUpdateState(e.target.value);
                      setShowUpdateStateError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      setShowUpdateStateError(!val || !isAlphabetic(val));
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                {/* Country */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_country">
                    Country:
                    <span className="text-danger">
                      {showUpdateCountryError ? " Country required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-control-sm"
                    id="update_country"
                    value={updateCountry}
                    onChange={(e) => {
                      setUpdateCountry(e.target.value);
                      setShowUpdateCountryError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      setShowUpdateCountryError(e.target.value === "");
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  >
                    <option value="">Select Country</option>
                    {countryData.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.long_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Currency */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label className="required-label" htmlFor="update_currency">
                    Currency:
                    <span className="text-danger">
                      {showUpdateCurrencyError ? " Currency required" : ""}
                    </span>
                  </label>
                  <select
                    className="form-select form-control-sm"
                    id="update_currency"
                    value={updateCurrency}
                    onChange={(e) => {
                      setUpdateCurrency(e.target.value);
                      setShowUpdateCurrencyError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      setShowUpdateCurrencyError(e.target.value === "");
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  >
                    <option value="">Select Currency</option>
                    {currencyData.map((currency) => (
                      <option key={currency.id} value={currency.id}>
                        {currency.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Customs Details */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_customs_details">
                    Custom Details:
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_customs_details"
                    placeholder="Enter Details"
                    value={updateCustomDetails}
                    onChange={(e) => setUpdateCustomDetails(e.target.value)}
                  />
                </div>

                {/* Hide If Destination */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_hide_if_destination">
                    Hide If Destination?
                  </label>
                  <select
                    className="form-select form-control-sm"
                    id="update_hide_if_destination"
                    value={updateHideIfDestination}
                    onChange={(e) => setUpdateHideIfDestination(e.target.value)}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>

                {/* Status */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_status">Status:</label>
                  <select
                    className="form-select form-control-sm"
                    id="update_status"
                    value={updateStatus}
                    onChange={(e) => setUpdateStatus(e.target.value)}
                  >
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>

                {/* Submit Button + Error Tooltip */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
                >
                  <div className="canvas-btn-row">
                    <Button
                      type="submit"
                      className="btn btn-inox-green border-0 canvas-button"
                      disabled={hasAnyUpdateError() || showUpdateLoader}
                    >
                      {showUpdateLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <i className="fa fa-edit"></i>{" "}
                          <span className="mx-2">Update</span>
                        </>
                      )}
                    </Button>

                    {(hasAnyUpdateError() || showUpdateValidationError) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={handleUpdateCheckValidationClick}
                          onMouseLeave={() =>
                            setIsUpdateValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isUpdateValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {updateValidationErrorArray.map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}

          {/* Terminals Tab */}
          {showUpdateTerminalDetails && (
            <div>
              <div className="row">
                <div className="col-12">
                  {!showUpdateTerminalForm ? (
                    <form onSubmit={addNewTerminal}>
                      <div className="row">
                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="terminal_name"
                          >
                            Terminal Name:
                            <span className="text-danger">
                              {showTerminalNameError ? " Name required" : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="terminal_name"
                            placeholder="Enter Name"
                            value={terminalName}
                            onChange={(e) => {
                              setTerminalName(e.target.value);
                              setShowTerminalNameError(false);
                            }}
                            onBlur={(e) =>
                              setShowTerminalNameError(e.target.value === "")
                            }
                          />
                        </div>
                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <Button
                            type="submit"
                            className="btn btn-sm btn-inox-green border-0 mt-4"
                            disabled={!terminalName}
                          >
                            {showAddTerminalLoader ? (
                              <Spinner
                                className="mx-5"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              "Add Terminal"
                            )}
                          </Button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <form onSubmit={updateTerminal}>
                      <div className="row">
                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_terminal_name"
                          >
                            Terminal Name:
                            <span className="text-danger">
                              {showUpdateTerminalNameError
                                ? " Name required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_terminal_name"
                            placeholder="Enter Name"
                            value={updateTerminalName}
                            onChange={(e) => {
                              setUpdateTerminalName(e.target.value);
                              setShowUpdateTerminalNameError(false);
                            }}
                            onBlur={(e) =>
                              setShowUpdateTerminalNameError(
                                e.target.value === "",
                              )
                            }
                          />
                        </div>
                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <Button
                            type="submit"
                            className="btn btn-sm btn-inox-green border-0 mt-4"
                            disabled={!updateTerminalName}
                          >
                            {showUpdateTerminalLoader ? (
                              <Spinner
                                className="mx-5"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              "Update Terminal"
                            )}
                          </Button>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>

              <div style={{ overflowX: "hidden" }}>
                <DataTable
                  columns={terminalcolumns}
                  data={terminalData}
                  progressPending={terminalDataPending}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center my-5">No Data Found</p>
                  }
                  pagination
                  highlightOnHover
                  customStyles={terminalTableCustomStyles}
                  dense
                  expandableRows
                  expandableRowsComponent={(props) => (
                    <ExpandableTerminalComponent
                      {...props}
                      chargeData={chargeData}
                      containerData={containerData}
                      currencyData={currencyData}
                      countryData={countryData}
                      loggedInUser={loggedInUser}
                    />
                  )}
                />
              </div>

              <Modal
                size="sm"
                show={showTerminalDeleteModal}
                onHide={() => setShowTerminalDeleteModal(false)}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to delete this terminal?</Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowTerminalDeleteModal(false)}
                  >
                    Close
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() =>
                      deleteSelectedTerminalRecord(terminalRecordForDelete?.id)
                    }
                  >
                    {showTerminalDeleteLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}

          {/* Uploads Tab */}
          {showUpdateUploadDetails && (
            <div>
              <form onSubmit={addPortUploads}>
                <div className="row">
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="uploads"
                      accept="image/*, .pdf"
                      onChange={(e) => {
                        handleUploadsFileChange(e.target.files);
                        setUploadFiles(e.target.files);
                      }}
                      multiple
                    />
                  </div>
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-10" : "col-md-10"} text-left mb-4`}
                  >
                    <Button
                      type="submit"
                      className="btn-inox-green border-0 btn-sm"
                      disabled={uploadFiles.length < 1}
                    >
                      {showUploadFilesLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span className="px-1">Upload</span>
                      )}
                    </Button>
                  </div>
                </div>
                {uploadFiles.length > 0 && (
                  <div className="row">
                    <div
                      className="col-12"
                      style={{ fontSize: 12, textAlign: "left" }}
                    >
                      Files:{" "}
                      {uploadFileNames.map((name, index) => (
                        <span key={index}>
                          {index !== 0 ? ", " : ""}
                          <b>{index + 1}:</b> {name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </form>

              {portUploads.length > 0 ? (
                <DataTable
                  columns={uploadcolumns}
                  data={portUploads}
                  progressPending={portUploadDataPending}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center table-no-data">
                      No Uploads Found
                    </p>
                  }
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              ) : (
                <p style={{ marginTop: 100 }}>No Uploads Found</p>
              )}

              <Modal
                size="sm"
                show={deletePortUploadModal}
                onHide={() => setDeletePortUploadModal(false)}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    Delete{" "}
                    <span style={{ fontSize: 10 }}>
                      ({deleteUploadFileName})
                    </span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to delete this file?</Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setDeletePortUploadModal(false)}
                  >
                    Close
                  </Button>
                  <Button variant="danger" onClick={deletePortUploads}>
                    {showDeleteUploadFilesLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={addNewPort}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_name">
                  Name:
                  <span className="text-danger">
                    {showNameError ? " Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_name"
                  placeholder="Enter Name"
                  value={addName}
                  onChange={(e) => {
                    setAddName(e.target.value);
                    setShowNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Type */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_type">Type:</label>
                <select
                  className="form-select form-control-sm"
                  id="add_type"
                  value={addType}
                  onChange={(e) => setAddType(e.target.value)}
                >
                  <option value="SEAPORT">SEAPORT</option>
                  <option value="DRYPORT">DRYPORT</option>
                </select>
              </div>

              {/* ITA Code */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_ita_code">
                  ITA Code:
                  <span className="text-danger">
                    {showItaCodeError ? " Code required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_ita_code"
                  placeholder="Enter Code"
                  value={addItaCode}
                  onChange={(e) => {
                    setAddItaCode(e.target.value);
                    setShowItaCodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowItaCodeError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* City */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_city">
                  City:
                  <span className="text-danger">
                    {showCityError ? " City required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_city"
                  placeholder="Enter City"
                  value={addCity}
                  onChange={(e) => {
                    setAddCity(e.target.value);
                    setShowCityError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCityError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Pincode */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_pincode">
                  Pincode:
                  <span className="text-danger">
                    {showPincodeError
                      ? addPincode
                        ? " Must contain only digits"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_pincode"
                  placeholder="Enter Pincode"
                  value={addPincode}
                  onChange={(e) => {
                    setAddPincode(e.target.value);
                    setShowPincodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowPincodeError(!val || !isNumeric(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* State */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_state">
                  State:
                  <span className="text-danger">
                    {showStateError
                      ? addState
                        ? " Must contain only letters"
                        : " Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_state"
                  placeholder="Enter State "
                  value={addState}
                  onChange={(e) => {
                    setAddState(e.target.value);
                    setShowStateError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowStateError(!val || !isAlphabetic(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Country */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_country">
                  Country:
                  <span className="text-danger">
                    {showCountryError ? " Country required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-control-sm"
                  id="add_country"
                  value={addCountry}
                  onChange={(e) => {
                    setAddCountry(e.target.value);
                    setShowCountryError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCountryError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Country</option>
                  {countryData.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.long_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Currency */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_currency">
                  Currency:
                  <span className="text-danger">
                    {showCurrencyError ? " Currency required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-control-sm"
                  id="add_currency"
                  value={addCurrency}
                  onChange={(e) => {
                    setAddCurrency(e.target.value);
                    setShowCurrencyError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowCurrencyError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Currency</option>
                  {currencyData.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Customs Details */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_customs_details">Custom Details:</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_customs_details"
                  placeholder="Enter Details"
                  value={addCustomsDetails}
                  onChange={(e) => setAddCustomsDetails(e.target.value)}
                />
              </div>

              {/* Hide If Destination */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_hide_if_destination">
                  Hide If Destination?
                </label>
                <select
                  className="form-select form-control-sm"
                  id="add_hide_if_destination"
                  value={addHideIfDestination}
                  onChange={(e) => setAddHideIfDestination(e.target.value)}
                >
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_status">Status:</label>
                <select
                  className="form-select form-control-sm"
                  id="add_status"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyAddError() || showAddLoader}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyAddError() || showValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {validationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PortMaster;
